import CheckoutPlatform from 'assets/images/checkoutPlatform.png';

const CheckoutOurPlatform = () => {
    return (
        <div className='py-12'>
            <div>
                <img 
                src={CheckoutPlatform} 
                alt="Checkout our platform"
                className='w-full h-full object-cover' 
                />
            </div>
            <div className='gradient-bg py-8 pb-10 flex flex-col gap-6 items-center justify-center'>
                <h3 className='sm:text-2xl text-xl font-semibold text-white'>Getting Started Quick & Easy</h3>
                <div>
                    <button className='btn-primary py-1.5'>Register Yourself</button>
                </div>
            </div>
        </div>
    )
}

export default CheckoutOurPlatform